import { render } from "./ButtonFBMessenger.vue?vue&type=template&id=1ee7d586&scoped=true"
import script from "./ButtonFBMessenger.vue?vue&type=script&lang=js"
export * from "./ButtonFBMessenger.vue?vue&type=script&lang=js"

import "./ButtonFBMessenger.vue?vue&type=style&index=0&id=1ee7d586&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ee7d586"]])

export default __exports__